import React from 'react';
import { Page, PageHeader, EmptyState } from '../../../ui';

/** Shown on manager-only Telephony pages to everyone else. */
const TelephonyAdminOnly: React.FC<{ title: string }> = ({ title }) => (
  <Page>
    <PageHeader eyebrow="Telephony" title={title} />
    <EmptyState
      title="This page is for telephony admins"
      description="Use the Dialer and Logs menus."
    />
  </Page>
);

export default TelephonyAdminOnly;
